import React from "react";
import { FieldSet } from "src/components/event_transaction/components/shared/Form/FieldSet";
import { Text } from "src/components/ui/Text";

const OrganizationalScopeForm = (props) => {
  const { control, disabled } = props;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-end gap-2">
        <Text variant="bold-14">Organizational Scope Document</Text>
        <Text variant="normal-10">
          Please upload the organizational scope document of the company
        </Text>
      </div>

      <div className="h-[10rem]">
        <FieldSet
          disabled={disabled}
          name="organizationalScope"
          type="file"
          control={control}
          label="Organizational Scope Document"
          fullWidth
          multiple
          multiplePreview="list"
        />
      </div>
    </div>
  );
};

export default OrganizationalScopeForm;
